import {
  AssignedUserType,
  ContactType,
  MerchantAccountStatus,
} from '../../core/constants';
import { StreetAddress } from '../streetAddress/streetAddress';
import { AssignedUser } from '../users/assignedUser';
import { InvoiceItem } from './invoiceItem';

// TODO (jacob): This should be be cleaned up
export class PayableInvoice {
  id: string;
  number: number;
  customerId: string;
  merchantId: string;
  status: string;
  dueDate: Date;
  amtDue: number;
  currencyCode: string;
  taxMagnified: number;
  memo: string;
  totalAmtDue: number;
  remainingPayments: number;
  DBA: string;
  merchantPhone: string;
  merchantEmail: string;
  firstName: string;
  lastName: string;
  customerEmail: string;
  customerPhone: string;
  invoiceItems: InvoiceItem[];
  isInstallment: boolean;
  agreementId: string;
  achEnabled: boolean;

  constructor(m: Partial<PayableInvoice>) {
    this.id = m.id || '';
    this.number = m.number || 0;
    this.customerId = m.customerId || '';
    this.merchantId = m.merchantId || '';
    this.amtDue = m.amtDue || 0;
    this.status = m.status || '';
    this.dueDate = m.dueDate || new Date();
    this.currencyCode = m.currencyCode || '';
    this.taxMagnified = m.taxMagnified || 0;
    this.memo = m.memo || '';
    this.totalAmtDue = m.totalAmtDue || 0;
    this.remainingPayments = m.remainingPayments || 0;
    this.DBA = m.DBA || '';
    this.merchantPhone = m.merchantPhone || '';
    this.merchantEmail = m.merchantEmail || '';
    this.firstName = m.firstName || '';
    this.lastName = m.lastName || '';
    this.customerPhone = m.customerPhone || '';
    this.customerEmail = m.customerEmail || '';
    this.invoiceItems = m.invoiceItems || [];
    this.isInstallment = m.isInstallment || false;
    this.agreementId = m.agreementId || '';
    this.achEnabled = m.achEnabled || false;
  }

  static createEmpty(): PayableInvoice {
    return new PayableInvoice({
      id: '',
      number: 0,
      customerId: '',
      merchantId: '',
      amtDue: 0,
      status: '',
      dueDate: new Date(),
      currencyCode: '',
      taxMagnified: 0,
      memo: '',
      totalAmtDue: 0,
      remainingPayments: 0,
      DBA: '',
      merchantPhone: '',
      merchantEmail: '',
      firstName: '',
      lastName: '',
      customerPhone: '',
      customerEmail: '',
      invoiceItems: [],
      isInstallment: false,
      agreementId: '',
      achEnabled: false,
    });
  }
}
